module.exports = __webpack_public_path__ + "static/media/support_dark.1ca122b0.svg";